var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip402_8478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip402_8478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.29 5.7C17.9 5.31 17.27 5.31 16.88 5.7L11.99 10.58L7.1 5.69C6.71 5.3 6.08 5.3 5.69 5.69C5.3 6.08 5.3 6.71 5.69 7.1L10.58 11.99L5.69 16.88C5.3 17.27 5.3 17.9 5.69 18.29C6.08 18.68 6.71 18.68 7.1 18.29L11.99 13.4L16.88 18.29C17.27 18.68 17.9 18.68 18.29 18.29C18.68 17.9 18.68 17.27 18.29 16.88L13.4 11.99L18.29 7.1C18.67 6.72 18.67 6.08 18.29 5.7Z",
    fill: "#148F2B",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseSvg);
export default __webpack_public_path__ + "static/media/ic_close_svg.78f4aaae12c3ed2e3ec3b9af0bf5dfcc.svg";
export { ForwardRef as ReactComponent };